/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiProjectsGetProjectIdByReferenceParams,
  ProjectChangeStatusDto,
  ProjectCopyDto,
  ProjectCreateDto,
  ProjectDto,
  ProjectListDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiProjects = (
    projectCreateDto?: BodyType<ProjectCreateDto>,
 signal?: AbortSignal
) => {


      return customInstance<number>(
      {url: `/api/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectCreateDto, signal
    },
      );
    }




export const getPostApiProjectsMutationKey = () => ['postApiProjects'] as const;

export const getPostApiProjectsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjects>>, TError,PostApiProjectsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiProjects>>, TError,PostApiProjectsMutationVariables, TContext> => {

const mutationKey = getPostApiProjectsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProjects>>, PostApiProjectsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postApiProjects(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProjects>>>
    export type PostApiProjectsMutationBody = BodyType<ProjectCreateDto> | undefined
    export type PostApiProjectsMutationError = ErrorType<unknown>
    export type PostApiProjectsMutationVariables = {data?: BodyType<ProjectCreateDto>}

    export const usePostApiProjects = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjects>>, TError,PostApiProjectsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProjects>>,
        TError,
        PostApiProjectsMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiProjectsMutationOptions(options), queryClient);
    }
    export const getApiProjects = (

 signal?: AbortSignal
) => {


      return customInstance<ProjectListDto>(
      {url: `/api/projects`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsQueryKey = () => {
    return [
    `/api/projects`
    ] as const;
    }


export const getGetApiProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjects>>> = ({ signal }) => getApiProjects(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjects>>>
export type GetApiProjectsQueryError = ErrorType<unknown>


export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiProjectsCopy = (
    projectCopyDto?: BodyType<ProjectCopyDto>,
 signal?: AbortSignal
) => {


      return customInstance<number>(
      {url: `/api/projects/copy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectCopyDto, signal
    },
      );
    }




export const getPostApiProjectsCopyMutationKey = () => ['postApiProjectsCopy'] as const;

export const getPostApiProjectsCopyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsCopy>>, TError,PostApiProjectsCopyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsCopy>>, TError,PostApiProjectsCopyMutationVariables, TContext> => {

const mutationKey = getPostApiProjectsCopyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProjectsCopy>>, PostApiProjectsCopyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postApiProjectsCopy(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProjectsCopyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProjectsCopy>>>
    export type PostApiProjectsCopyMutationBody = BodyType<ProjectCopyDto> | undefined
    export type PostApiProjectsCopyMutationError = ErrorType<unknown>
    export type PostApiProjectsCopyMutationVariables = {data?: BodyType<ProjectCopyDto>}

    export const usePostApiProjectsCopy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsCopy>>, TError,PostApiProjectsCopyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProjectsCopy>>,
        TError,
        PostApiProjectsCopyMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiProjectsCopyMutationOptions(options), queryClient);
    }
    export const getApiProjectsIdId = (
    id: number,
 signal?: AbortSignal
) => {


      return customInstance<ProjectDto>(
      {url: `/api/projects/id/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsIdIdQueryKey = (id: number,) => {
    return [
    `/api/projects/id/${id}`
    ] as const;
    }


export const getGetApiProjectsIdIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjectsIdId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsIdId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsIdIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjectsIdId>>> = ({ signal }) => getApiProjectsIdId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsIdId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsIdIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjectsIdId>>>
export type GetApiProjectsIdIdQueryError = ErrorType<unknown>


export function useGetApiProjectsIdId<TData = Awaited<ReturnType<typeof getApiProjectsIdId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsIdId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsIdId>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsIdId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsIdId<TData = Awaited<ReturnType<typeof getApiProjectsIdId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsIdId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsIdId>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsIdId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsIdId<TData = Awaited<ReturnType<typeof getApiProjectsIdId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsIdId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjectsIdId<TData = Awaited<ReturnType<typeof getApiProjectsIdId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsIdId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsIdIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiProjectsGetProjectIdByReference = (
    params?: GetApiProjectsGetProjectIdByReferenceParams,
 signal?: AbortSignal
) => {


      return customInstance<number[]>(
      {url: `/api/projects/GetProjectIdByReference`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiProjectsGetProjectIdByReferenceQueryKey = (params?: GetApiProjectsGetProjectIdByReferenceParams,) => {
    return [
    `/api/projects/GetProjectIdByReference`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiProjectsGetProjectIdByReferenceQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError = ErrorType<unknown>>(params?: GetApiProjectsGetProjectIdByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsGetProjectIdByReferenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>> = ({ signal }) => getApiProjectsGetProjectIdByReference(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsGetProjectIdByReferenceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>>
export type GetApiProjectsGetProjectIdByReferenceQueryError = ErrorType<unknown>


export function useGetApiProjectsGetProjectIdByReference<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApiProjectsGetProjectIdByReferenceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsGetProjectIdByReference<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError = ErrorType<unknown>>(
 params?: GetApiProjectsGetProjectIdByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsGetProjectIdByReference<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError = ErrorType<unknown>>(
 params?: GetApiProjectsGetProjectIdByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjectsGetProjectIdByReference<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError = ErrorType<unknown>>(
 params?: GetApiProjectsGetProjectIdByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectIdByReference>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsGetProjectIdByReferenceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiProjectsId = (
    id: number,
 signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/projects/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiProjectsIdMutationKey = () => ['deleteApiProjectsId'] as const;

export const getDeleteApiProjectsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiProjectsId>>, TError,DeleteApiProjectsIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiProjectsId>>, TError,DeleteApiProjectsIdMutationVariables, TContext> => {

const mutationKey = getDeleteApiProjectsIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiProjectsId>>, DeleteApiProjectsIdMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteApiProjectsId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiProjectsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiProjectsId>>>

    export type DeleteApiProjectsIdMutationError = ErrorType<unknown>
    export type DeleteApiProjectsIdMutationVariables = {id: number}

    export const useDeleteApiProjectsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiProjectsId>>, TError,DeleteApiProjectsIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiProjectsId>>,
        TError,
        DeleteApiProjectsIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteApiProjectsIdMutationOptions(options), queryClient);
    }
    export const getApiProjectsGetProjectStatusProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<number>(
      {url: `/api/projects/GetProjectStatus/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsGetProjectStatusProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/projects/GetProjectStatus/${projectId}`
    ] as const;
    }


export const getGetApiProjectsGetProjectStatusProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsGetProjectStatusProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>> = ({ signal }) => getApiProjectsGetProjectStatusProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsGetProjectStatusProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>>
export type GetApiProjectsGetProjectStatusProjectIdQueryError = ErrorType<unknown>


export function useGetApiProjectsGetProjectStatusProjectId<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsGetProjectStatusProjectId<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsGetProjectStatusProjectId<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjectsGetProjectStatusProjectId<TData = Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsGetProjectStatusProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsGetProjectStatusProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiProjectsChangeProjectStatus = (
    projectChangeStatusDto?: BodyType<ProjectChangeStatusDto>,
 signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/projects/ChangeProjectStatus`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: projectChangeStatusDto, signal
    },
      );
    }




export const getPutApiProjectsChangeProjectStatusMutationKey = () => ['putApiProjectsChangeProjectStatus'] as const;

export const getPutApiProjectsChangeProjectStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsChangeProjectStatus>>, TError,PutApiProjectsChangeProjectStatusMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsChangeProjectStatus>>, TError,PutApiProjectsChangeProjectStatusMutationVariables, TContext> => {

const mutationKey = getPutApiProjectsChangeProjectStatusMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiProjectsChangeProjectStatus>>, PutApiProjectsChangeProjectStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiProjectsChangeProjectStatus(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiProjectsChangeProjectStatusMutationResult = NonNullable<Awaited<ReturnType<typeof putApiProjectsChangeProjectStatus>>>
    export type PutApiProjectsChangeProjectStatusMutationBody = BodyType<ProjectChangeStatusDto> | undefined
    export type PutApiProjectsChangeProjectStatusMutationError = ErrorType<unknown>
    export type PutApiProjectsChangeProjectStatusMutationVariables = {data?: BodyType<ProjectChangeStatusDto>}

    export const usePutApiProjectsChangeProjectStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsChangeProjectStatus>>, TError,PutApiProjectsChangeProjectStatusMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiProjectsChangeProjectStatus>>,
        TError,
        PutApiProjectsChangeProjectStatusMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiProjectsChangeProjectStatusMutationOptions(options), queryClient);
    }
    export const putApiProjectsUpdateDimensionDocUpdatedProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/projects/UpdateDimensionDocUpdated/${projectId}`, method: 'PUT', signal
    },
      );
    }




export const getPutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationKey = () => ['putApiProjectsUpdateDimensionDocUpdatedProjectId'] as const;

export const getPutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsUpdateDimensionDocUpdatedProjectId>>, TError,PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsUpdateDimensionDocUpdatedProjectId>>, TError,PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationVariables, TContext> => {

const mutationKey = getPutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiProjectsUpdateDimensionDocUpdatedProjectId>>, PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  putApiProjectsUpdateDimensionDocUpdatedProjectId(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiProjectsUpdateDimensionDocUpdatedProjectId>>>

    export type PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationError = ErrorType<unknown>
    export type PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationVariables = {projectId: number}

    export const usePutApiProjectsUpdateDimensionDocUpdatedProjectId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsUpdateDimensionDocUpdatedProjectId>>, TError,PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiProjectsUpdateDimensionDocUpdatedProjectId>>,
        TError,
        PutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiProjectsUpdateDimensionDocUpdatedProjectIdMutationOptions(options), queryClient);
    }
